<i18n>
{
  "fr": {
    "CompletedWork": "Temps de résolution",
    "ID": "ID",
    "Title": "Titre"
  }
}
</i18n>

<template>
  <section v-if="projectBugs">
    <table class="table table-bordered table-striped">
      <thead class="thead-dark">
        <tr>
          <th scope="col">{{ $t('ID') }}</th>
          <th scope="col">{{ $t('Title') }}</th>
          <th scope="col">{{ $t('CompletedWork') }}</th>
        </tr>
      </thead>
      <tbody
        v-on="$listeners">
        <tr
          v-for="bug in projectBugs.bugs"
          :key="bug.id">
          <td scope="row">{{ bug.id }}</td>
          <td>{{ bug.title }}</td>
          <td>{{ bug.completedWork }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('bugs', ['projectBugs']),
  },
  created() {
    this.$store.commit('bugs/loadedProject', this.$route.params.projectName);
  },
};
</script>
